import fundSwitchReducer from "./fundSwitchReducer.js";

export default fundSwitchReducer;
